export const genKey = () => Math.random().toFixed(10).substring(2);